import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App.js";
import { createCmtsHostRuntime } from "./app/appRuntime.js";
import { registerCmtsServiceWorker } from "./pwa/serviceWorkerRegistration.js";

import type { CmtsAppEnvironment } from "./app/appConfig.js";

import "./styles.css";

const appEnvironment = (
  import.meta.env.VITE_CMTS_APP_ENV || "local"
) as CmtsAppEnvironment;

const apiBaseUrl =
  import.meta.env.VITE_CMTS_API_BASE_URL || "/api";

const configuredTenantCode =
  import.meta.env.VITE_CMTS_DEFAULT_TENANT_CODE ||
  import.meta.env.VITE_CMTS_TENANT_CODE ||
  undefined;

const runtime = createCmtsHostRuntime({
  apiBaseUrl,

  tenantCode: configuredTenantCode,

  defaultLandingPath:
    import.meta.env.VITE_CMTS_DEFAULT_LANDING_PATH ||
    "/cmts/my-workspace",

  appEnvironment,
});

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("CMTS_ROOT_ELEMENT_MISSING");
}

createRoot(rootElement).render(
  <React.StrictMode>
    <App runtime={runtime} />
  </React.StrictMode>,
);

registerCmtsServiceWorker({
  enabled:
    import.meta.env.PROD &&
    import.meta.env.VITE_CMTS_ENABLE_SERVICE_WORKER !== "false",
});